import { Link } from "@inertiajs/react";

import Button from "hardcover-ui/components/Button";
import Icon from "hardcover-ui/components/Icon";
import {
  menuIconTheme,
  menuItemTheme,
} from "hardcover-ui/theme/components/menu";
import useSignOut from "hooks/user/useSignOut";
import faSignOut from "icons/duotone/arrow-right-from-bracket.svg";
import classNames from "lib/classNames";

interface Props {
  active?: boolean;
}

export default function LogoutLinkActive({ active = false }: Props) {
  const { signOut } = useSignOut();

  return (
    <>
      <Button
        variant="unstyled"
        size="md"
        className={classNames(
          active
            ? menuItemTheme.variant.primaryActive
            : menuItemTheme.variant.primary,
          "w-full rounded-md py-3 focus:outline-hidden group",
        )}
        onClick={signOut}
      >
        <Icon
          icon={faSignOut}
          size="lg"
          className={classNames(
            active
              ? `${menuIconTheme.variant.primaryActive}`
              : `${menuIconTheme.variant.primary} `,
          )}
        />
        Sign out
      </Button>

      {/* Preload the homepage to make the redirect faster */}
      <Link className="hidden" href="/">
        Home
      </Link>
    </>
  );
}
